module.exports = __webpack_public_path__ + "assets/c5824bc1712c23995737a2c7cb00cf57.svg";